// api.js - Modificato per integrazione Basic Auth custom
// Dynamically determine the API base URL
const isProduction = true
// Use absolute URL for production, relative path for development
const API_BASE_URL = isProduction
  ? "https://dieffebi-demo.ayea.it/api"
  : "/api-proxy"

// NUOVO: Import del servizio Basic Auth
import basicAuthService from "./ImprovedBasicAuth"
import { debug } from "./debug"

// CRITICAL FIX: Standardized headers with proper UTF-8 encoding + Basic Auth
const getStandardHeaders = () => {
  const baseHeaders = {
    "Content-Type": "application/json; charset=utf-8",
    Accept: "application/json; charset=utf-8",
    "Accept-Charset": "utf-8",
  }

  // NUOVO: Aggiungi automaticamente l'header Basic Auth se disponibile
  const authHeader = basicAuthService.getAuthHeader()
  if (authHeader) {
    baseHeaders.Authorization = authHeader
  }

  return baseHeaders
}

// NUOVO: Headers per FormData (upload) con Basic Auth
const getFormDataHeaders = () => {
  const authHeaders = {}
  const authHeader = basicAuthService.getAuthHeader()

  if (authHeader) {
    authHeaders.Authorization = authHeader
  }

  // Non impostare Content-Type per FormData, lascia che il browser lo gestisca
  return authHeaders
}

// CRITICAL FIX: Safe JSON stringify that preserves UTF-8 characters and data integrity
const safeStringify = (data) => {
  return JSON.stringify(data)
}

// CRITICAL FIX: Enhanced error handling con gestione Basic Auth
const handleResponse = async (response) => {
  if (!response.ok) {
    let errorText
    try {
      errorText = await response.text()
      const errorJson = JSON.parse(errorText)

      // NUOVO: Gestione speciale per errori Basic Auth
      if (response.status === 401) {
        // Se l'errore è di autenticazione, clear delle credenziali e ricarica se in admin mode
        basicAuthService.clearCredentials()
        if (
          window.location.search.includes("admin=true") ||
          window.location.hash.includes("admin")
        ) {
          // Ricarica la pagina per mostrare il form di login
          setTimeout(() => window.location.reload(), 1000)
        }
        throw new Error(
          "Credenziali non valide o scadute. Ricarica la pagina per effettuare nuovamente il login."
        )
      }

      throw new Error(
        errorJson.error || `HTTP ${response.status}: ${response.statusText}`
      )
    } catch (e) {
      // Se non è JSON, gestisci come prima
      if (response.status === 401) {
        basicAuthService.clearCredentials()
        if (
          window.location.search.includes("admin=true") ||
          window.location.hash.includes("admin")
        ) {
          setTimeout(() => window.location.reload(), 1000)
        }
        throw new Error(
          "Credenziali non valide o scadute. Ricarica la pagina per effettuare nuovamente il login."
        )
      }
      throw new Error(
        errorText || `HTTP ${response.status}: ${response.statusText}`
      )
    }
  }
  return response.json()
}

// MODIFICATO: Upload API con Basic Auth
export const uploadFile = async (file) => {
  try {
    const formData = new FormData()
    formData.append("thumbnail", file)
    const response = await fetch(`${API_BASE_URL}/upload.php`, {
      method: "POST",
      headers: getFormDataHeaders(), // NUOVO: Include Basic Auth headers
      body: formData,
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

// Products API (tutte modificate per usare i nuovi headers con Basic Auth)
export const fetchProducts = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/products.php?flat=true`, {
      headers: getStandardHeaders(),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in fetchProducts:", error)
    throw error
  }
}

export const fetchProductStructure = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/products.php?structure=true`,
      {
        headers: getStandardHeaders(),
      }
    )
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in fetchProductStructure:", error)
    throw error
  }
}

export const fetchCategories = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      headers: getStandardHeaders(),
    })
    const data = await handleResponse(response)
    return Object.keys(data.categories || {})
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const fetchCategory = async (categoryName) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/products.php?category=${encodeURIComponent(
        categoryName
      )}`,
      {
        headers: getStandardHeaders(),
      }
    )
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in fetchCategory:", error)
    throw error
  }
}

export const fetchFamily = async (familyName) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/products.php?family=${encodeURIComponent(familyName)}`,
      {
        headers: getStandardHeaders(),
      }
    )
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const fetchProductByCode = async (code) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/products.php?code=${encodeURIComponent(code)}`,
      {
        headers: getStandardHeaders(),
      }
    )
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in fetchProductByCode:", error)
    throw error
  }
}

// CRITICAL FIX: Category operations with proper UTF-8 handling and data integrity + Basic Auth
export const addCategory = async (name) => {
  try {
    const payload = { action: "addCategory", name }
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      method: "POST",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in addCategory:", error)
    throw error
  }
}

export const updateCategory = async (originalName, newName) => {
  try {
    const payload = { action: "updateCategory", originalName, name: newName }
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      method: "PUT",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in updateCategory:", error)
    throw error
  }
}

export const deleteCategory = async (name) => {
  try {
    const payload = { action: "deleteCategory", name }
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      method: "DELETE",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in deleteCategory:", error)
    throw error
  }
}

// CRITICAL FIX: Family operations with proper UTF-8 handling and data integrity + Basic Auth
export const addFamily = async (categoryName, familyName, defaultData = {}) => {
  try {
    const payload = {
      action: "addFamily",
      category: categoryName,
      name: familyName,
      ...defaultData,
    }
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      method: "POST",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in addFamily:", error)
    throw error
  }
}

export const updateFamily = async (
  categoryName,
  originalName,
  newName,
  defaultData = {}
) => {
  try {
    const payload = {
      action: "updateFamily",
      category: categoryName,
      originalName: originalName,
      name: newName,
      ...defaultData,
    }
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      method: "PUT",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in updateFamily:", error)
    throw error
  }
}

export const deleteFamily = async (categoryName, familyName) => {
  try {
    const payload = {
      action: "deleteFamily",
      category: categoryName,
      name: familyName,
    }
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      method: "DELETE",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in deleteFamily:", error)
    throw error
  }
}

export const addProduct = async (productData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      method: "POST",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(productData),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in addProduct:", error)
    throw error
  }
}

export const updateProduct = async (productData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      method: "PUT",
      headers: getStandardHeaders(),
      body: safeStringify(productData),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in updateProduct:", error)
    throw error
  }
}
export const deleteProduct = async (code) => {
  try {
    const payload = { code }
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      method: "DELETE",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in deleteProduct:", error)
    throw error
  }
}

// Materials API - FIXED + Basic Auth (continua con tutte le altre funzioni...)
export const fetchMaterials = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/materials.php`, {
      headers: getStandardHeaders(),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in fetchMaterials:", error)
    throw error
  }
}

export const fetchMaterialsByTechnicalType = async (technicalType) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/materials.php?technicalType=${encodeURIComponent(
        technicalType
      )}`,
      {
        headers: getStandardHeaders(),
      }
    )
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const fetchMaterialById = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/materials.php?id=${encodeURIComponent(id)}`,
      {
        headers: getStandardHeaders(),
      }
    )
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const fetchTechnicalTypes = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/materials.php?technicalTypes=true`,
      {
        headers: getStandardHeaders(),
      }
    )
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const addMaterial = async (materialData) => {
  try {
    debug.api("Adding material with UTF-8 preservation:", materialData)
    const cleanedData = cleanAndPreserveData(materialData)
    const response = await fetch(`${API_BASE_URL}/materials.php`, {
      method: "POST",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(cleanedData),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const updateMaterial = async (materialData) => {
  try {
    debug.api("Updating material with UTF-8 preservation:", materialData)
    const cleanedData = cleanAndPreserveData(materialData)
    const response = await fetch(`${API_BASE_URL}/materials.php`, {
      method: "PUT",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(cleanedData),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const deleteMaterial = async (id) => {
  try {
    const payload = { id }
    const response = await fetch(`${API_BASE_URL}/materials.php`, {
      method: "DELETE",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const importMaterials = async (materialsObject) => {
  try {
    debug.api("Importing materials with UTF-8 preservation:", materialsObject)
    const cleanedData = cleanAndPreserveData(materialsObject)
    const payload = {
      action: "import",
      materials: cleanedData,
    }
    const response = await fetch(`${API_BASE_URL}/materials.php`, {
      method: "POST",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

// Material Links API - FIXED + Basic Auth
export const fetchMaterialLinks = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/material-links.php`, {
      headers: getStandardHeaders(),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in fetchMaterialLinks:", error)
    throw error
  }
}

export const fetchMaterialLinksByTechnicalName = async (technicalName) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/material-links.php?technicalName=${encodeURIComponent(
        technicalName
      )}`,
      {
        headers: getStandardHeaders(),
      }
    )
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const fetchMaterialLinkById = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/material-links.php?id=${encodeURIComponent(id)}`,
      {
        headers: getStandardHeaders(),
      }
    )
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const addMaterialLink = async (linkData) => {
  try {
    debug.api("Adding material link with UTF-8 preservation:", linkData)
    const cleanedData = cleanAndPreserveData(linkData)
    const response = await fetch(`${API_BASE_URL}/material-links.php`, {
      method: "POST",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(cleanedData),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const updateMaterialLink = async (linkData) => {
  try {
    debug.api("Updating material link with UTF-8 preservation:", linkData)
    const cleanedData = cleanAndPreserveData(linkData)
    const response = await fetch(`${API_BASE_URL}/material-links.php`, {
      method: "PUT",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(cleanedData),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const deleteMaterialLink = async (id) => {
  try {
    const payload = { id }
    const response = await fetch(`${API_BASE_URL}/material-links.php`, {
      method: "DELETE",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const fetchProductViews = async (productCode) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/views.php?code=${encodeURIComponent(productCode)}`,
      {
        headers: getStandardHeaders(),
      }
    )
    if (!response.ok) {
      throw new Error("Failed to fetch product views")
    }
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const addProductView = async (
  productCode,
  viewData,
  saveToFamily = false
) => {
  try {
    debug.api("Adding product view with UTF-8 preservation:", {
      productCode,
      viewData,
      saveToFamily,
    })
    const cleanedViewData = cleanAndPreserveData(viewData)
    // CORRECTED: Match the views.php expected structure
    const payload = {
      productCode,
      view: cleanedViewData,
      saveToFamily: saveToFamily,
    }
    const response = await fetch(`${API_BASE_URL}/views.php`, {
      method: "POST",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const updateProductView = async (
  productCode,
  viewLabel,
  viewData,
  isFromFamily = false
) => {
  try {
    debug.api("Updating product view with UTF-8 preservation:", {
      productCode,
      viewLabel,
      viewData,
      isFromFamily,
    })
    const cleanedViewData = cleanAndPreserveData(viewData)
    // CORRECTED: Match the views.php expected structure
    const payload = {
      productCode,
      viewLabel,
      view: cleanedViewData,
      isFromFamily: isFromFamily,
    }
    const response = await fetch(`${API_BASE_URL}/views.php`, {
      method: "PUT",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

export const deleteProductView = async (
  productCode,
  viewLabel,
  isFromFamily = false
) => {
  try {
    // CORRECTED: Match the views.php expected structure
    const payload = {
      productCode,
      viewLabel,
      isFromFamily: isFromFamily,
    }
    const response = await fetch(`${API_BASE_URL}/views.php`, {
      method: "DELETE",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error:", error)
    throw error
  }
}

// Reorder operations - FIXED + Basic Auth
export const reorderCategories = async (categoryOrder) => {
  try {
    const payload = { action: "reorderCategories", categoryOrder }
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      method: "PUT",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in reorderCategories:", error)
    throw error
  }
}

export const reorderFamilies = async (categoryName, familyOrder) => {
  try {
    const payload = {
      action: "reorderFamilies",
      category: categoryName,
      familyOrder,
    }
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      method: "PUT",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in reorderFamilies:", error)
    throw error
  }
}

export const reorderProducts = async (
  categoryName,
  familyName,
  productOrder
) => {
  try {
    const payload = {
      action: "reorderProducts",
      category: categoryName,
      family: familyName,
      productOrder,
    }
    const response = await fetch(`${API_BASE_URL}/products.php`, {
      method: "PUT",
      headers: getStandardHeaders(), // INCLUDE Basic Auth
      body: safeStringify(payload),
    })
    return await handleResponse(response)
  } catch (error) {
    debug.warn.api("API Error in reorderProducts:", error)
    throw error
  }
}

const cleanAndPreserveData = (data) => {
  if (typeof data === "string") {
    return data.trim()
  }
  if (Array.isArray(data)) {
    return data.map(cleanAndPreserveData)
  }
  if (data && typeof data === "object") {
    const cleaned = {}
    for (const [key, value] of Object.entries(data)) {
      cleaned[key] = cleanAndPreserveData(value)
    }
    return cleaned
  }
  return data
}
